import type { Chain, LowerHex } from '@pkg/evm'

type FetchTransactionCounts = (args: {
  chain: Chain
  addrsses: readonly LowerHex[]
}) => Promise<readonly number[]>

export const fetchTransactionCounts: FetchTransactionCounts = async ({
  chain,
  addrsses,
}) => {
  const transactionCounts = await Promise.all(
    addrsses.map(async (address) =>
      chain.client.call({
        clientCall: (client) => client.getTransactionCount({ address }),
      }),
    ),
  )
  return transactionCounts
}
